import * as React from 'react';
import { EActiveView } from '../../types/view';
import { EHeadingType } from '../../types/headingType';
import { useSelector } from 'react-redux';
import { selectView } from '../../selectors/view/view';
import { HomeownersBanner } from '../../components/HomeownersBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export var PromoBannerContainer = function PromoBannerContainer() {
  var _useSelector = useSelector(selectView),
    active = _useSelector.active,
    data = _useSelector.data;
  switch (active) {
    case EActiveView.AuthenticationRegistration:
    case EActiveView.PhoneAuth:
      switch (data === null || data === void 0 ? void 0 : data.headingType) {
        case EHeadingType.NewOfferForm:
          return /*#__PURE__*/_jsx(HomeownersBanner, {});
        default:
          return null;
      }
    default:
      return null;
  }
};